import React from "react";

const ScoreboardHeader = ({ competitionName, competitionDates, competitionCity }) => {
  return (
    <div className="scoreboard-react-header">
      <div className="competition-name">
        {competitionName}   
      </div>
      <div className="competition-dates-city">
        {competitionDates} • {competitionCity}
      </div>    
    </div>
  );
};

export default ScoreboardHeader;